<template>
  <div class="collapse">
    <div
      class="hd"
      :class="{
        fold: !configMainShow['readText']
      }"
      @click="configMainShow['readText'] = !configMainShow['readText']"
    >
      <div class="title-fix">
        <i class="fa-angle-down"></i>
        <span>语音播报</span>
        <span
          class="el-switch"
          @click.stop="
            isElectron
              ? toggleEnable('readText', '语音播报')
              : switchReadTextTips()
          "
        >
          <el-switch v-model="configure.readText.enable" disabled></el-switch>
        </span>
      </div>
    </div>
    <div
      class="bd"
      @click="
        isElectron
          ? isNaN(featureList['readText'].timeRemaining)
            ? shoWDialogBuy(
                featureList['readText']['productKey'],
                '基础包',
                'readText'
              )
            : featureList['readText'].timeRemaining <= 0
            ? showFunctionalRenewal(true)
            : configure.readText.enable
            ? ''
            : toggleEnable('readText', '语音播报')
          : ''
      "
      :class="{
        'no-buy': isElectron && isNaN(featureList['readText'].timeRemaining),
        expired: isElectron && featureList['readText'].timeRemaining <= 0,
        'shut-off': isElectron && !configure.readText.enable,
        locked: !isElectron
      }"
    >
      <el-row>
        <el-col :span="5">声音配置</el-col>
        <el-col :span="19">
          <div class="block-tag">
            <div class="pc-block">
              语音读弹幕，想让直播间的人都听到，要将机器人挂在主播电脑上。
            </div>
            <div class="mb-block">
              语音读弹幕，手机版是将机器人挂在小虎弟电脑上，所以您听不到。
            </div>
          </div>
          <el-row>
            <el-col :span="5">音色</el-col>
            <el-col :span="19">
              <el-radio-group
                v-model="configure.readText.readTextTabPosition"
                size="small"
              >
                <el-radio-button label="0">女声</el-radio-button>
                <el-radio-button label="1">男声</el-radio-button>
                <el-radio-button label="3">男播音</el-radio-button>
                <el-radio-button label="4">女童</el-radio-button>
              </el-radio-group>
              <el-button
                type="success"
                size="mini"
                icon="fa-volume-up"
                @click="audition"
                class="audition"
                >试听</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">音量</el-col>
            <el-col :span="19">
              <el-slider
                v-model="configure.readText.volume"
                :min="1"
                :max="15"
              ></el-slider>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">语速</el-col>
            <el-col :span="19">
              <el-slider
                v-model="configure.readText.rate"
                :min="1"
                :max="9"
              ></el-slider>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="5">语调</el-col>
            <el-col :span="19">
              <el-slider
                v-model="configure.readText.intonation"
                :min="1"
                :max="9"
              ></el-slider>
            </el-col>
          </el-row>
          <div class="row-padding"></div>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row v-if="true">
        <el-col :span="5">播报内容</el-col>
        <el-col :span="19">
          <el-row>
            <el-col :span="12">
              <el-switch
                v-model="configure.readText.broadcastWelcomeEnable"
              ></el-switch
              >来宾欢迎
            </el-col>
            <el-col :span="12">
              <el-switch
                v-model="configure.readText.broadcastGiftEnable"
              ></el-switch
              >礼物答谢
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-switch
                v-model="configure.readText.broadcastGuideEnable"
              ></el-switch
              >定时引导
            </el-col>
            <el-col :span="12">
              <el-switch
                v-model="configure.readText.broadcastReplyEnable"
              ></el-switch
              >智能答复
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-switch
                v-model="configure.readText.broadcastAIEnable"
              ></el-switch
              >AI互动
            </el-col>
            <el-col :span="12">
              <el-switch
                v-model="configure.readText.broadcastCommonEnable"
              ></el-switch
              >普通弹幕
            </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="12"
              v-if="!isNaN(featureList['begGift'].timeRemaining)"
            >
              <el-switch
                v-model="configure.readText.broadcastBegGiftEnable"
              ></el-switch
              >智能狗
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-switch v-model="configure.readText.readEmoji"></el-switch>表情
            </el-col>
            <el-col :span="12">
              <el-switch v-model="configure.readText.readFansNick"></el-switch
              >粉丝昵称
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-switch v-model="configure.readText.welcomeWhiteid"></el-switch
              >防调戏（“啊啊啊”，无聊叠词不播报。）
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-switch v-model="configure.readText.onlyVoice"></el-switch
              >仅播报语音，不输出弹幕<span class="red"
                >（慎重！机器人将不输出任何弹幕）</span
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="dash-line"></div>
      <el-row v-if="true">
        <el-col :span="5">用户设定</el-col>
        <el-col :span="19">
          <el-radio-group
            class="broadcast-common"
            v-model="broadcastCommonDetail"
            @change="broadcastCommonChange"
          >
            <div class="row-padding">
              <el-radio label="allEnable">播报所有用户</el-radio>
            </div>
            <div class="row-padding">
              <el-radio label="hasBadgeEnable">播报带本房间牌子的用户</el-radio>
            </div>
          </el-radio-group>
        </el-col>
      </el-row>
      <div class="reset-row">
        <el-button
          type="danger"
          size="small"
          @click="resetDefault('语音播报', 'readText')"
          >「语音播报」恢复默认</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getAIToken } from "@/api";
import { configCommon } from '@/mixins/configCommon'
import { commonFuc } from '@/mixins/commonFuc'
import { btts } from '@/utils/baidu_tts_cors'
export default {
  mixins: [configCommon, commonFuc],
  data() {
    return {
      // 百度语音token
      baiduToken: '',
      // 播报普通弹幕详细设置弹窗
      broadcastCommonDetail: 'allEnable'
    }
  },
  props: {
    configure: {
      type: Object,
      default: null
    },
    featureList: {
      type: Object,
      default: null
    },
    ticket: {
      type: String,
      default: ''
    },
    configMainShow: {
      type: Object,
      default: () => {
        return {
          account: true,
          welcome: true,
          giftTks: true,
          guide: true,
          autoReply: true,
          AIChat: true,
          readText: true,
          autoBan: true,
          keyPerson: true,
          begGift: true,
          guessNum: true,
          duty: true,
          global: true
        }
      }
    }
  },
  mounted() {
    this.broadcastCommonDetailFormat()
  },
  methods: {
    switchReadTextTips() {
      this.$message({
        dangerouslyUseHTMLString: true,
        type: 'error',
        message:
          '<strong>操作失败</strong><p style="margin-top: 5px;">本功能需要在客户端内配置</p>'
      })
    },
    audition() {
      let self = this
      if (!this.baiduToken) {
        getAIToken(
          {
            ticket: this.ticket
          },
          { notify: false }
        ).then(res => {
          self.baiduToken = res.data.access_token
          btts(
            {
              tex: '欢迎来到直播间！',
              tok: self.baiduToken,
              spd: self.configure.readText.rate,
              pit: self.configure.readText.intonation,
              vol: self.configure.readText.volume,
              per: self.configure.readText.readTextTabPosition
            },
            {
              volume: 0.3,
              autoDestory: true,
              timeout: 600000,
              hidden: false,
              onInit: function(htmlAudioElement) {},
              onSuccess: function(htmlAudioElement) {
                htmlAudioElement.play()
              },
              onError: function(errorText) {
                self.baiduToken = ''
              },
              onTimeout: function() {}
            }
          )
        })
      } else {
        btts(
          {
            tex: '欢迎来到直播间！',
            tok: self.baiduToken,
            spd: self.configure.readText.rate,
            pit: self.configure.readText.intonation,
            vol: self.configure.readText.volume,
            per: self.configure.readText.readTextTabPosition
          },
          {
            volume: 0.3,
            autoDestory: true,
            timeout: 60000,
            hidden: false,
            onInit: function(htmlAudioElement) {},
            onSuccess: function(htmlAudioElement) {
              htmlAudioElement.play()
            },
            onError: function(errorText) {
              self.baiduToken = ''
            },
            onTimeout: function() {}
          }
        )
      }
    },
    broadcastCommonChange(e) {
      if (e == 'hasBadgeEnable') {
        this.configure.readText.broadcastCommonDetail.hasBadgeEnable = true
        this.configure.readText.broadcastCommonDetail.allEnable = false
      }
      if (e == 'allEnable') {
        this.configure.readText.broadcastCommonDetail.hasBadgeEnable = false
        this.configure.readText.broadcastCommonDetail.allEnable = true
      }
    },
    broadcastCommonDetailFormat() {
      if (this.configure.readText.broadcastCommonDetail.hasBadgeEnable) {
        this.broadcastCommonDetail = 'hasBadgeEnable'
      }
      if (this.configure.readText.broadcastCommonDetail.allEnable) {
        this.broadcastCommonDetail = 'allEnable'
      }
    }
  }
}
</script>
